import { UseFormReturn } from 'react-hook-form';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface DasHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

const DAS_HOVER_FIELDS = [
  { name: 'das_trackId', label: 'Track ID', description: 'Show track ID when hovering DAS target' },
  { name: 'das_site', label: 'Site', description: 'Show site when hovering DAS target' },
  { name: 'das_priority', label: 'Priority', description: 'Show priority when hovering DAS target' },
  { name: 'das_lastReportTimestamp', label: 'Last Report', description: 'Show last report timestamp when hovering DAS target' },
  { name: 'das_latitude', label: 'Latitude', description: 'Show latitude when hovering DAS target' },
  { name: 'das_longitude', label: 'Longitude', description: 'Show longitude when hovering DAS target' },
  { name: 'das_speed', label: 'Speed', description: 'Show speed when hovering DAS target' },
  { name: 'das_heading', label: 'Heading', description: 'Show heading when hovering DAS target' },
  { name: 'das_accuracy', label: 'Accuracy', description: 'Show accuracy when hovering DAS target' },
  { name: 'das_lastOrigin', label: 'Last Origin', description: 'Show last origin when hovering DAS target' },
] as const;

export const DasHoverLabels = ({ form }: DasHoverLabelsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {DAS_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
